import React, { Fragment } from 'react';
import { Link } from 'gatsby';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import MenuIcon from '../Icon/MenuIcon';
import { Button } from '@material-ui/core';

const routes = [
  { to: '/', text: '¿Qué es factoraje financiero?' },
  { to: '/inversionistas', text: 'Inversionistas' },
  { to: '/deudores', text: 'Deudores'  },
  { to: '/factorados', text: 'Factorados' },
]

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

export default function TemporaryDrawer() {
  const classes = useStyles({});
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  type DrawerSide = 'top' | 'left' | 'bottom' | 'right';
  const toggleDrawer = (side: DrawerSide, open: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent,
  ) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const sideList = (side: DrawerSide) => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        {routes.map((route, index) => (
          <ListItem button key={route.text}>
            <Link to={route.to} className="top-0 mr-16 block text-gray-700 text-lg md:text-xl">
              {route.text}
            </Link>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <div className="md:hidden">
      <Button
        style={{right: '20px', top: '10px', position: 'fixed'}}
        className="text-gray-700"
        onClick={toggleDrawer('left', true)}
      >
        <MenuIcon />
      </Button>
      <Drawer open={state.left} onClose={toggleDrawer('left', false)}>
        {sideList('left')}
      </Drawer>
    </div>
  );
}
